<template>
    <v-card class="mx-auto" @click="goToDynamicCollection(collection.url)" v-bind="props">
      <div class="image_wrapper">
      <img v-if="showImage"
      :src="getImageUrl"
      :alt="$i18n.locale === 'nl' ? collection.title_dutch : collection.title_english"
           @error="onImageError"
      />
      <div v-else>{{ generateSlug }}</div>
    </div>
      <v-card-title class="pt-4 truncate2">{{ $i18n.locale === "nl" ? collection.title_dutch : collection.title_english }}</v-card-title>
      <v-card-text class="description truncate2">
         {{ $i18n.locale === 'nl' ? collection.description_dutch : collection.description_english }}
      </v-card-text>
      <!-- v-card-text class="material_count">
        {{ collection.materials_count }} leermaterialen
      </v-card-text-->
    </v-card>
  </template>

  <script>
  export default {
    name: "DynamicCollectionCard",
    props: {
      collection: {
        type: Object,
        default: null,
        required: true,
      },
      handleCollectionClick: {
        type: Function,
        params: 1,
        default: () => {},
      },
    },
    data() {
      return {
        showImage: true
      };
    },
    methods: {
      goToDynamicCollection(url) {
        let domain = location.origin.replace("search.", "");
        location.href = `${domain}${url}`;
      },
      onImageError() {
        this.showImage = false;
      },
    },
    computed: {
      generateSlug() {
        const title = this.$i18n.locale === "nl" ? this.collection.title_dutch : this.collection.title_english;
        const words = title.split(" ");
        const slugArray = words.map(word => {
            return word.charAt(0).toUpperCase();
        });

        let slug = slugArray.join("");
        return slug.slice(0, 2);
      },
      getImageUrl() {
          const bundle_service_url = window.BUNDLE_SERVICE_URL || process.env.VUE_APP
          return `${window.BUNDLE_SERVICE_URL || process.env.VUE_APP_BUNDLE_SERVICE_URL}/api/v1/bundle_image/${this.collection.id}`
      }
    },
  };
  </script>

  <style lang="less" scoped>
  @import "./../../variables";
  .v-card {
    height: 100%;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    &:hover {
      .v-card__title, .v-card__text {
        background: rgba(@light-grey, 0.5);
      }
    }
}

.v-card:hover:deep(.v-card__title) {
  opacity: 0.5;
  color: red;
  background-color: black;
}
  .image_wrapper {
    height: 146px;
    background-color: @green;
    font-size: 40px;
    font-weight: 700;
    color: @white;
    font-family: Nunito;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  img {
    width: 100%;
    height: 100%;
    border-radius: 8px 8px 0 0;
  }
  .v-card__title {
    max-height: 84px;
    font-family: Nunito;
    font-weight: 700;
    line-height: 30px;
    flex-grow: 1;
    display: flex;
    align-items: flex-start;
  }

  .v-card__text.description {
    font-size: 16px;
    color: black;
    height: 48px;
  }

  .v-card__text.material_count {
    font-size: 14px;
    color: @dark-grey;
  }

  .truncate2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

  </style>
